module.exports = __webpack_public_path__ + "static/media/Cats eyes 07_SPANSKA-mixdown.4634906e.mp3";